import { render, staticRenderFns } from "./OwnerCreate.vue?vue&type=template&id=5270d090&"
import script from "./OwnerCreate.vue?vue&type=script&lang=js&"
export * from "./OwnerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports